import { View, ViewDensity } from "@common/types/views/views";
import { ChartOfAccountsRow } from "@components/accounting/chartOfAccounts/utils";
import { ViewConfig } from "@lib/views";
import { CoaMappingPreviewNameCell } from "./cells/CoaMappingPreviewNameCell";
import { CoaMappingPreviewSourcesCell } from "./cells/CoaMappingPreviewSourcesCell";

export enum CoaMappingPreviewColumn {
    NAME = "name",
    MAPPED_SOURCES = "mappedSources",
}

export type CoaMappingPreviewViewConfig = ViewConfig<
    ChartOfAccountsRow,
    CoaMappingPreviewColumn,
    never
>;

export const createCoaMappingPreviewViewConfig = ({
    providerLabel,
}: {
    providerLabel: string;
}): CoaMappingPreviewViewConfig => ({
    columns: {
        [CoaMappingPreviewColumn.NAME]: {
            accessorKey: "classification",
            name: "Account",
            header: "Account",
            cell: CoaMappingPreviewNameCell,
            immutable: true,
            minSize: 320,
            maxSize: 1200,
        },
        [CoaMappingPreviewColumn.MAPPED_SOURCES]: {
            accessorKey: "id",
            name: `Mapped ${providerLabel} accounts`,
            header: `Mapped ${providerLabel} accounts`,
            cell: CoaMappingPreviewSourcesCell,
            minSize: 220,
            maxSize: 400,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: CoaMappingPreviewColumn.NAME,
        childrenKey: "accounts",
    },
});

export const buildCoaMappingPreviewView = (): View => ({
    columns: [
        { id: CoaMappingPreviewColumn.NAME, options: { pin: "left" } },
        { id: CoaMappingPreviewColumn.MAPPED_SOURCES },
    ],
    filters: {},
    options: {
        density: ViewDensity.MD,
    },
});
